import Crud from '@/stores/crudBase';
import api from '@/apis/gl/gLVoucherAPI.js';
var crud = new Crud('approveVoucherGLEndYearTransferTab', api);

const state = {
  ...crud.state,
  _config: {
    table: 'gl_voucher',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
